import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-1180ffa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "row mt-4 text-center text-md-start" }
const _hoisted_3 = { class: "col-md-6 col-lg-3 mb-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center justify-content-md-start align-items-md-start mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "black-logo",
    alt: "Logo"
  })
], -1))
const _hoisted_5 = { class: "col-md-3 offset-lg-3 mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "black-logo mb-3",
  style: {"height":"22px"},
  alt: "AiCharge"
}, null, -1))
const _hoisted_7 = { class: "list-unstyled" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "col-md-3 text-center mb-4" }
const _hoisted_10 = { class: "fw-bold" }
const _hoisted_11 = { class: "d-flex flex-row justify-content-center align-items-center" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "d-flex flex-wrap gap-5 align-items-center justify-content-center mb-3" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "d-flex flex-column align-items-center justify-content-center gap-1 fs-10px" }

import { useSocialMedia } from "@/composables/socialMedia";
import ParagraphOne from "@/components/base-components/paragraphs/ParagraphOne.vue";
import { useNavigationLinks } from "@/composables/navigationLinks";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const { legalPagesLinks } = useNavigationLinks();
const { socialMedia } = useSocialMedia();

const { t } = useI18n();

const images = [
  {
    src: require("../../assets/images/card-logos/american-express.png"),
    alt: "American Express",
  },
  {
    src: require("../../assets/images/card-logos/diners-club.png"),
    alt: "Diners Club",
  },
  {
    src: require("../../assets/images/card-logos/maestro.png"),
    alt: "Maestro",
  },
  {
    src: require("../../assets/images/card-logos/visa.png"),
    alt: "Visa",
  },
  {
    src: require("../../assets/images/card-logos/mastercard.png"),
    alt: "Mastercard",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(ParagraphOne, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("components.app-footer.footer-text")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalPagesLinks), (link, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "mb-2"
            }, [
              _createElementVNode("a", {
                target: "_blank",
                href: link.to,
                class: "text-decoration-none text-black"
              }, _toDisplayString(_unref(t)(link.name)), 9, _hoisted_8)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("components.app-footer.social-media")), 1),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialMedia), (media, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "mx-2"
            }, [
              _createElementVNode("a", {
                style: {"width":"40px","height":"40px"},
                href: media.to,
                target: "_blank",
                class: "text-decoration-none d-block bg-primary rounded-circle d-flex align-items-center justify-content-center"
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["bi fs-4 text-white p-2", media.fa])
                }, null, 2)
              ], 8, _hoisted_12)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(images, (image) => {
        return _createElementVNode("div", {
          key: image.src,
          class: "border border-1 border-light"
        }, [
          _createElementVNode("img", {
            src: image.src,
            alt: image.alt,
            height: "30"
          }, null, 8, _hoisted_14)
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", null, _toDisplayString(_unref(t)("components.app-footer.company-details.copyright")), 1),
      _createElementVNode("div", null, _toDisplayString(_unref(t)("components.app-footer.company-details.address")), 1),
      _createElementVNode("div", null, _toDisplayString(_unref(t)("components.app-footer.company-details.ems-edb")), 1),
      _createElementVNode("div", null, _toDisplayString(_unref(t)("components.app-footer.company-details.email")) + ": aicharge@email.com | " + _toDisplayString(_unref(t)("components.app-footer.company-details.phone")) + ": +389 75 201 677 ", 1)
    ])
  ]))
}
}

})